import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {map} from 'rxjs/operators';
import {ModuleEnum, ModuleModel} from "../models/module-model";
import {environment} from "../../environments/environment";

@Injectable({providedIn: 'root'})
export class ModuleRegistryService {
  readonly modules: { [key: string]: ModuleModel };

  constructor(private auth: AuthService) {
    this.modules = {
      FRAMEWORK: new ModuleModel(
        1,
        ModuleEnum.FRAMEWORK,
        'assets/images/login/hub-logo.png',
        environment.modulesPath.falconVS,
        (email: string, password: string) =>
          this.auth
            .login(email, password)
            .next(user =>
              this.auth.getPermissions(user)
                .pipe(map(perms => ({user, permissions: perms})))
            )
            .next(ctx =>
              this.auth.getLegacyId(ctx.user)
                .pipe(map(id => ({...ctx, legacyId: id})))
            )
            .next(ctx =>
              this.auth.handleRetorno(ctx)
            )
      ),

      FALCON: new ModuleModel(
        1,
        ModuleEnum.FALCON,
        'assets/images/falcon_logo/Velsis_Produto_FalconVS_azul_previa.png',
        environment.modulesPath.falconVS,
        (email: string, password: string) =>
          this.auth
            .login(email, password)
            .next(user =>
              this.auth.getPermissions(user)
                .pipe(map(perms => ({user, permissions: perms})))
            )
            .next(ctx =>
              this.auth.handleRetorno(ctx)
            )
      ),

      ADMINISTRADOR: new ModuleModel(
        1,
        ModuleEnum.ADMINISTRADOR,
        null,
        environment.modulesPath.falconVS,
        (email: string, password: string) =>
          this.auth
            .login(email, password)
            .next(user =>
              this.auth.getPermissions(user)
                .pipe(map(perms => ({user, permissions: perms})))
            )
            .next(ctx =>
              this.auth.handleRetorno(ctx)
            )
      ),
    };
  }

  /** atalho para pegar um módulo pelo “enum key” */
  get(name: ModuleEnum): ModuleModel {
    return this.modules[name];
  }
}
